export default "__VITE_PUBLIC_ASSET__2e878623__"